import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';
import { ApiRouteSubWorkOrderService } from '../../../api/elite/routes/sub-work-order.service';
import { ApiRouteDepartmentService } from '../../../api/elite/routes/department.service';
import { map, switchMap } from 'rxjs/operators';
import { QualityControlSubWorkOrder } from '../../../common/quality-control/model/sub-work-order-qc.ts';
import { SchedulerSubWorkOrder } from '../../../common/scheduler/models/sub-work-order';

@Injectable()
export class SchedulerStageApiService {
  protected readonly departmentService = inject(SingleDepartmentService);
  protected readonly schedulerApiRouter = inject(ApiRouteSubWorkOrderService);
  protected readonly departmentApiRouter = inject(ApiRouteDepartmentService);

  getSchedulerData(
    stageName: string
  ): Observable<QualityControlSubWorkOrder[]> {
    return this.departmentApiRouter
      .getOneByName(this.departmentService.NAME)
      .pipe(
        switchMap((dep) => {
          const query = new URLSearchParams({
            stage: stageName,
            quantityOut: 'true',
            includeInspection: 'true',
          });
          return this.schedulerApiRouter.getByTypeAndStage(
            dep.id,
            query.toString()
          );
        }),
        map((res: SchedulerSubWorkOrder[]) => {
          return this.transformItemToWorkOrder(res);
        })
      );
  }

  protected transformItemToWorkOrder(
    res: SchedulerSubWorkOrder[]
  ): QualityControlSubWorkOrder[] {
    return res.map((el) => QualityControlSubWorkOrder.fromObject(el));
  }
}
